module.exports = __webpack_public_path__ + "img/55C404_BCFA0E_97F004_7AE104-256px.18e1bfe3.png";